import React from "react";
import styled from "styled-components";

const StyledCard = styled.div`
  border-radius: 24px !important;
  background-color: ${(props) => props.theme.colors.background.primary};
  border: 1px solid ${(props) => props.theme.colors.border.light};
  border-radius: 24px !important;
  box-shadow: ${(props) => props.theme.shadows.sm};
  overflow: hidden;
  transition: all ${(props) => props.theme.transitions.base};

  * {
    border-radius: inherit;
  }

  ${(props) =>
    props.hoverable &&
    `
    cursor: pointer;

    &:hover {
      box-shadow: ${props.theme.shadows.md};
      transform: translateY(-2px);
    }
  `}

  ${(props) =>
    props.padding &&
    `
    padding: ${props.theme.spacing[props.padding] || props.theme.spacing.lg};
  `}
`;

const CardHeader = styled.div`
  padding: ${(props) => props.theme.spacing.lg};
  border-bottom: 1px solid ${(props) => props.theme.colors.border.light};

  &:last-child {
    border-bottom: none;
  }
`;

const CardTitle = styled.h3`
  margin: 0;
  font-size: ${(props) => props.theme.typography.h4};
  font-weight: 600;
  color: ${(props) => props.theme.colors.text.primary};
`;

const CardDescription = styled.p`
  margin: 0.5rem 0 0 0;
  color: ${(props) => props.theme.colors.text.secondary};
  font-size: ${(props) => props.theme.typography.body};
`;

const CardContent = styled.div`
  padding: ${(props) => props.theme.spacing.lg};
`;

const CardFooter = styled.div`
  padding: ${(props) => props.theme.spacing.lg};
  border-top: 1px solid ${(props) => props.theme.colors.border.light};
  background-color: ${(props) => props.theme.colors.background.secondary};

  &:first-child {
    border-top: none;
    background-color: transparent;
  }
`;

const CardImage = styled.div`
  width: 100%;
  height: ${(props) => props.height || "200px"};
  background-image: url(${(props) => props.src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const Card = ({
  children,
  hoverable = false,
  padding,
  onClick,
  ...props
}) => {
  return (
    <StyledCard
      hoverable={hoverable}
      padding={padding}
      onClick={onClick}
      {...props}
    >
      {children}
    </StyledCard>
  );
};

Card.Header = CardHeader;
Card.Title = CardTitle;
Card.Description = CardDescription;
Card.Content = CardContent;
Card.Footer = CardFooter;
Card.Image = CardImage;
